<template>
  <Biddingresult />
</template>
<script>
import Biddingresult from '@/views/purchaser/bidmanagementpur/mybidding/biddingresult.vue'
export default {
  components: { Biddingresult }
}
</script>
